export const EXIT_WORKTREE_TOOL_NAME = 'ExitWorktree'
